// extracted by mini-css-extract-plugin
var _1 = "ClientNotesMobileFiltersDialog_actions__UYW-R";
var _2 = "ClientNotesMobileFiltersDialog_container__F3O35";
export { _1 as "actions", _2 as "container" }
